var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "280 -680 539.54 539.54",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M468.46-281.54q-79.23-4.61-133.84-61.54Q280-400 280-480q0-83.08 58.46-141.54T480-680q80 0 136.92 54.23 56.93 54.23 61.54 133.46L646.23-504q-9-62-56.11-103Q543-648 480-648q-70 0-119 49t-49 119q0 63 41.38 110.5Q394.77-322 456-313zm320.77 141.08L602.46-329l-40.92 103.77L480-480l254.77 81.54L631-358.54l188.54 187.77z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftClick);
export default __webpack_public_path__ + "static/media/left_click.1a35f827c3d32cf899b245f736d2f14c.svg";
export { ForwardRef as ReactComponent };